export default __webpack_public_path__ + "static/media/wave-front.94510f5c.svg";